export default __webpack_public_path__ + "static/media/fixed-res1.3ceab331.jpg";